import { FC, useMemo } from "react";

import jsonParse from "web/utils/data/parser/string/jsonParse";
import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { MenuData } from "web/types/Menu";

import MainMenu from "./mainMenu";
import MainMenuContainerWithCategoryData from "./mainMenuContainerWithCategoryData";
import useCategoryIds from "./utils/useCategoryIds";

interface IMainMenuContainerWithCategoryIdsProps {
  menu: string;
}

const MainMenuContainerWithCategoryIds: FC<
  IMainMenuContainerWithCategoryIdsProps
> = ({ menu }) => {
  const menuParsed = useMemo(
    () => (menu ? jsonParse<MenuData>(menu) : []),
    [menu]
  ) as MenuData;

  const categoryIds = useCategoryIds(menuParsed);

  switch (true) {
    case !isArrayHasItems(menuParsed): {
      return null;
    }
    case !!isArrayHasItems(categoryIds): {
      return (
        <MainMenuContainerWithCategoryData
          ids={categoryIds}
          menu={menuParsed}
        />
      );
    }
    default: {
      return <MainMenu menu={menuParsed} />;
    }
  }
};

export default MainMenuContainerWithCategoryIds;
